import { render } from "./servidores.vue?vue&type=template&id=4474da16&scoped=true"
import script from "./servidores.vue?vue&type=script&lang=js"
export * from "./servidores.vue?vue&type=script&lang=js"

import "./servidores.vue?vue&type=style&index=0&id=4474da16&lang=scss&scoped=true"
import "./servidores.vue?vue&type=style&index=1&id=4474da16&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4474da16"]])

export default __exports__